// extracted by mini-css-extract-plugin
export default {"skeleton":"Skeleton_skeleton__vqT72","shine":"Skeleton_shine__bRhTd"};